/** AutoMapa SEO page types and reference data (Milestone 25). */

export const SEO_PAGE_TYPES = {
  CITY: "city",
  CITY_BODY_TYPE: "city_body_type",
  CITY_FINANCING: "city_financing",
  CITY_TRANSMISSION: "city_transmission",
  CITY_ECONOMY: "city_economy",
  MAKE: "make",
  MAKE_CITY: "make_city",
  MODEL: "model",
  MODEL_CITY: "model_city",
  BODY_TYPE: "body_type",
  BODY_TYPE_CITY: "body_type_city",
  BUDGET: "budget",
  BUDGET_CITY: "budget_city",
  DEALER_CITY: "dealer_city",
  GUIDE: "guide",
};

export const SEO_CITIES = [
  { slug: "medellin", name: "Medellín", region: "Antioquia" },
  { slug: "envigado", name: "Envigado", region: "Antioquia" },
  { slug: "sabaneta", name: "Sabaneta", region: "Antioquia" },
  { slug: "itagui", name: "Itagüí", region: "Antioquia" },
  { slug: "bello", name: "Bello", region: "Antioquia" },
  { slug: "rionegro", name: "Rionegro", region: "Antioquia" },
  { slug: "bogota", name: "Bogotá", region: "Cundinamarca" },
  { slug: "cali", name: "Cali", region: "Valle del Cauca" },
];

export const SEO_NEARBY_CITIES = {
  medellin: ["envigado", "sabaneta", "itagui", "bello", "rionegro"],
  envigado: ["medellin", "sabaneta", "itagui"],
  sabaneta: ["medellin", "envigado", "itagui"],
  itagui: ["medellin", "envigado", "sabaneta"],
  bello: ["medellin", "rionegro"],
  rionegro: ["medellin", "bello"],
  bogota: [],
  cali: [],
};

export const SEO_POPULAR_MAKES = [
  { slug: "mazda", name: "Mazda" },
  { slug: "toyota", name: "Toyota" },
  { slug: "chevrolet", name: "Chevrolet" },
  { slug: "renault", name: "Renault" },
  { slug: "kia", name: "Kia" },
  { slug: "hyundai", name: "Hyundai" },
  { slug: "nissan", name: "Nissan" },
  { slug: "ford", name: "Ford" },
];

export const SEO_MODELS = {
  mazda: [{ slug: "cx-5", name: "CX-5" }],
  toyota: [{ slug: "prado", name: "Prado" }, { slug: "corolla", name: "Corolla" }],
  chevrolet: [{ slug: "onix", name: "Onix" }, { slug: "spark", name: "Spark" }],
  renault: [{ slug: "duster", name: "Duster" }],
  kia: [{ slug: "picanto", name: "Picanto" }],
  hyundai: [{ slug: "tucson", name: "Tucson" }],
  nissan: [{ slug: "frontier", name: "Frontier" }],
  ford: [{ slug: "escape", name: "Escape" }],
};

/** Antioquia metro cities in M26 first content set — may index with unique content when inventory is empty. */
export const SEO_M26_MAJOR_CITY_SLUGS = new Set([
  "medellin",
  "envigado",
  "sabaneta",
  "itagui",
  "bello",
  "rionegro",
]);

export const SEO_BUDGET_RANGES = [
  { slug: "hasta-30-millones", label: "Hasta 30 millones", minCop: 0, maxCop: 30_000_000 },
  { slug: "30-a-50-millones", label: "30 a 50 millones", minCop: 30_000_000, maxCop: 50_000_000 },
  { slug: "50-a-80-millones", label: "50 a 80 millones", minCop: 50_000_000, maxCop: 80_000_000 },
  { slug: "80-a-120-millones", label: "80 a 120 millones", minCop: 80_000_000, maxCop: 120_000_000 },
  { slug: "mas-de-120-millones", label: "Más de 120 millones", minCop: 120_000_000, maxCop: null },
];

export const SEO_BODY_TYPES = [
  { slug: "automoviles", name: "Automóviles", filterValue: "Sedán" },
  { slug: "camionetas", name: "Camionetas", filterValue: "SUV" },
  { slug: "pickups", name: "Pickups", filterValue: "Pickup" },
  { slug: "familiares", name: "Familiares", filterValue: "Hatchback" },
  { slug: "electricos", name: "Eléctricos", filterValue: "Eléctrico" },
  { slug: "hibridos", name: "Híbridos", filterValue: "Híbrido" },
  { slug: "comerciales", name: "Comerciales", filterValue: "Comercial" },
];

export const SEO_SITE_NAME = "AutoMapa";
export const SEO_DEFAULT_OG_IMAGE = "/icons/icon-512.svg";
export const AUTOMAPA_CLIENT_VIEW_SLUG = "automap";

/** Minimum inventory to index auto-generated combo pages without explicit approval. */
export const SEO_MIN_INVENTORY_TO_INDEX = 1;
